import PartnerDesignsView from './PartnerDesignsView';

export default PartnerDesignsView;
